import React, { useState, useEffect, useContext } from 'react';
import ContactsDataGrid from '../../components/Contacts/Page/ContactsDataGrid';
import FilterComponent from '../../components/Contacts/Page/FilterComponent';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import ActionsButton from '../../components/Lead/Page/ActionsButton';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { AuthContext } from '../../context/AuthContext';
import useApiManager from '../../utils/Api/apiManager';

const ContactsPage = () => {
  const { userInfo } = useContext(AuthContext);
  const { post } = useApiManager();
  const [filters, setFilters] = useState(() => {
    const saved = localStorage.getItem("contactsFilters");
    try {
      const parsed = JSON.parse(saved);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });
  
  useEffect(() => {
    if (filters.length >= 0) {
      localStorage.setItem('contactsFilters', JSON.stringify(filters));
    }
  }, [filters]);

  const [triggerFetch, setTriggerFetch] = useState(false); // when deleting a row, refetching the data in datagrid
  const [selectedRows, setSelectedRows] = useState([]); // State to store selected row IDs

  // Function to handle row selection
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection); // Store selected row IDs
  };

  useEffect(() => {
      document.title = "Contacts - iLead CRM";
    }, []);

  const handleExport = async () => {
    try {
      const response = await post('/contacts/paged/export', {
        pageNumber: 1,
        pageSize: 5000,
        filters: filters,
        sortField: 'createdAt',
        sortDescending: true
      }, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `contacts_export_${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting contacts:', error);
    }
  };

  return (<>
    <Box sx={{ p: 2, height: '100%', display: 'flex' }}>
      <Grid container spacing={2} sx={{ height: '100%' }}>
        <Grid item xs={2.7} sx={{ height: '100%' }}>
          <Paper elevation={3} sx={{ height: 'calc(100vh - 105px)', p: 1, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
            {/* Ensure FilterComponent also takes full height */}
            <FilterComponent filters={filters} setFilters={setFilters} sx={{ flex: 1, overflow: 'auto', boxSizing: 'border-box' }} />
          </Paper>
        </Grid>

        <Grid item xs={9.3} sx={{ height: '100%' }}>
          <Paper
            elevation={3}
            sx={{
              height: 'calc(100vh - 105px)',
              display: 'flex',
              flexDirection: 'column',
              p: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <h3>Contacts</h3>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Link to="/contacts/create">
                  <Button variant="contained" type="submit">Create Contact</Button>
                </Link>
                <ActionsButton itemIds={selectedRows} setSelectedRows={setSelectedRows} setTriggerFetch={setTriggerFetch} />
                {(userInfo?.roles?.includes("Admin") || userInfo?.roles?.includes("Manager")) && (
                  <Button
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                )}
              </Box>
            </Box>

            <Box sx={{ flex: 1, overflow: 'hidden' }}>
              {/* Ensure CampaignsDataGrid takes up full height */}
              <ContactsDataGrid filters={filters} selectedRows={selectedRows} onSelectionModelChange={handleSelectionChange} triggerFetch={triggerFetch} setTriggerFetch={setTriggerFetch} />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>

  </>
  )
};

export default ContactsPage;
